import { Component, OnInit } from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Subscription } from 'rxjs';
import { HeaderService } from '../header/header.service';
import { ConfigService } from '../services/config.service';
import PerfectScrollbar from 'perfect-scrollbar';
declare const collapseMenu: any;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  isCollapsed = true;  
  subscriber: Subscription | undefined;
  public config: PerfectScrollbarConfigInterface = {};
  constructor(public configService:ConfigService,  public headerService: HeaderService) { }
  schedulePermissionList :any=[];
  insACQschedulePermissionList :any=[];
  insuranceFormschedulePermissionList :any=[];
  mceschedulePermissionList :any=[];

  uploadWorkbenchPermissionList:any=[];
  insACQuploadWorkbenchPermissionList:any=[];
  insuranceFormuploadWorkbenchPermissionList:any=[];
  mceuploadWorkbenchPermissionList:any=[];

  auditReportPermissionList :any=[];
  insACQauditReportPermissionList :any=[];
  insuranceFormauditReportPermissionList :any=[];
  mceauditReportPermissionList :any=[];
  
  userPermissionList:any=[];
  insACQuserPermissionList:any=[];
  insuranceFormuserPermissionList:any=[];
  mceuserPermissionList:any=[];

  reviewCrawlPermissionList:any=[];
  insACQreviewCrawlPermissionList:any=[];
  insuranceFormreviewCrawlPermissionList:any=[];
  mcereviewCrawlPermissionList:any=[];

  missedActionPermissionList:any=[];
  insACQmissedActionPermissionList:any=[];
  insuranceFormmissedActionPermissionList:any=[];
  mcemissedActionPermissionList:any=[];

  instanceAndSchedulesPermissionList:any=[];
  insACQinstanceAndSchedulesPermissionList:any=[];
  insuranceForminstanceAndSchedulesPermissionList:any=[];
  mceinstanceAndSchedulesPermissionList:any=[];

  missedDataPermissionList:any=[];
  insACQmissedDataPermissionList:any=[];
  insuranceFormmissedDataPermissionList:any=[];
  mcemissedDataPermissionList:any=[];
  syncRCMDataPermissionList:any=[];
  getCrawledDataPermissionList:any=[];
  manageSummaryParameterMappingPermissionList:any=[];
  manageRecrawlURLConfigPermissionList:any=[];

  manageQueryBuilderPermissionList:any=[];

  ngOnInit(): void {
    
    this.subscriber = this.headerService.menuObs$.subscribe(data => this.LocationChanged(data));
    this.uploadWorkbenchPermissionList = sessionStorage.getItem("uploadWorkbenchPermissionList");
    this.schedulePermissionList = sessionStorage.getItem("schedulePermissionList");
    this.auditReportPermissionList = sessionStorage.getItem("auditReportPermissionList");
    this.userPermissionList = sessionStorage.getItem("userPermissionList");
    this.reviewCrawlPermissionList = sessionStorage.getItem("reviewCrawlPermissionList");
    this.missedActionPermissionList = sessionStorage.getItem("missedActionPermissionList");
    this.instanceAndSchedulesPermissionList = sessionStorage.getItem("instanceAndSchedulesPermissionList");
    this.missedDataPermissionList = sessionStorage.getItem("missedDataPermissionList");
    this.syncRCMDataPermissionList = sessionStorage.getItem("syncRCMDataPermissionList");
    this.getCrawledDataPermissionList = sessionStorage.getItem("getCrawledDataPermissionList");
    this.manageSummaryParameterMappingPermissionList = sessionStorage.getItem("manageSummaryParameterMappingPermissionList");
    this.manageRecrawlURLConfigPermissionList = sessionStorage.getItem("manageRecrawlURLConfigPermissionList");
    this.manageQueryBuilderPermissionList = sessionStorage.getItem("manageQueryBuilderPermissionList");


    //Insurance ACQ
    this.insACQuploadWorkbenchPermissionList = sessionStorage.getItem("insACQuploadWorkbenchPermissionList");
    this.insACQschedulePermissionList = sessionStorage.getItem("insACQschedulePermissionList");
    this.insACQauditReportPermissionList = sessionStorage.getItem("insACQauditReportPermissionList");
    this.insACQuserPermissionList = sessionStorage.getItem("insACQuserList");
    this.insACQreviewCrawlPermissionList = sessionStorage.getItem("insACQreviewCrawlPermissionList");
    this.insACQmissedActionPermissionList = sessionStorage.getItem("insACQmissedActionPermissionList");
    this.insACQinstanceAndSchedulesPermissionList = sessionStorage.getItem("insACQinstanceAndSchedulesPermissionList");
    this.insACQmissedDataPermissionList = sessionStorage.getItem("insACQmissedDataPermissionList");

    //Insurance Form
    this.insuranceFormuploadWorkbenchPermissionList = sessionStorage.getItem("insuranceFormuploadWorkbenchPermissionList");
    this.insuranceFormschedulePermissionList = sessionStorage.getItem("insuranceFormschedulePermissionList");
    this.insuranceFormauditReportPermissionList = sessionStorage.getItem("insuranceFormauditReportPermissionList");
    this.insuranceFormuserPermissionList = sessionStorage.getItem("insuranceFormuserList");
    this.insuranceFormreviewCrawlPermissionList = sessionStorage.getItem("insuranceFormreviewCrawlPermissionList");
    this.insuranceFormmissedActionPermissionList = sessionStorage.getItem("insuranceFormmissedActionPermissionList");
    this.insuranceForminstanceAndSchedulesPermissionList = sessionStorage.getItem("insuranceForminstanceAndSchedulesPermissionList");
    this.insuranceFormmissedDataPermissionList = sessionStorage.getItem("insuranceFormmissedDataPermissionList");

    //MCE
    this.mceuploadWorkbenchPermissionList = sessionStorage.getItem("mceuploadWorkbenchPermissionList");
    this.mceschedulePermissionList = sessionStorage.getItem("mceschedulePermissionList");
    this.mceauditReportPermissionList = sessionStorage.getItem("mceauditReportPermissionList");
    this.mceuserPermissionList = sessionStorage.getItem("mceuserList");
    this.mcereviewCrawlPermissionList = sessionStorage.getItem("mcereviewCrawlPermissionList");
    this.mcemissedActionPermissionList = sessionStorage.getItem("mcemissedActionPermissionList");
    this.mceinstanceAndSchedulesPermissionList = sessionStorage.getItem("mceinstanceAndSchedulesPermissionList");
    this.mcemissedDataPermissionList = sessionStorage.getItem("mcemissedDataPermissionList");
  } 
  private ps: PerfectScrollbar | null = null;
 ngAfterViewInit(): void {
    const container = document.querySelector('.scrollingContent');
    console.log(container); // Check if the container is correctly selected
    if (container) {
      this.ps = new PerfectScrollbar(container as HTMLElement, {
        wheelPropagation: false,
        suppressScrollX: true  // Disable horizontal scrolling
      });
     
    } else {
     
    }
}


  toggleReviewData() {
    this.isCollapsed = !this.isCollapsed;
    setTimeout(() => {
      this.updateScrollbar();
    }, 100);  // Ensure the DOM is updated before updating the scrollbar
  }

  updateScrollbar(): void {
    if (this.ps) {
      this.ps.update();
    }
  }
  LocationChanged(data: any) {
    
    //if (data) 
    {
      this.uploadWorkbenchPermissionList = sessionStorage.getItem("uploadWorkbenchPermissionList");
      this.schedulePermissionList = sessionStorage.getItem("schedulePermissionList");
      this.auditReportPermissionList = sessionStorage.getItem("auditReportPermissionList");
      this.userPermissionList = sessionStorage.getItem("userPermissionList");
      this.reviewCrawlPermissionList = sessionStorage.getItem("reviewCrawlPermissionList");
      this.missedActionPermissionList = sessionStorage.getItem("missedActionPermissionList");
      this.instanceAndSchedulesPermissionList = sessionStorage.getItem("instanceAndSchedulesPermissionList");
      this.missedDataPermissionList = sessionStorage.getItem("missedDataPermissionList");
      this.syncRCMDataPermissionList = sessionStorage.getItem("syncRCMDataPermissionList");
      this.getCrawledDataPermissionList = sessionStorage.getItem("getCrawledDataPermissionList");
      this.manageSummaryParameterMappingPermissionList = sessionStorage.getItem("manageSummaryParameterMappingPermissionList");
      this.manageRecrawlURLConfigPermissionList = sessionStorage.getItem("manageRecrawlURLConfigPermissionList");
      this.manageQueryBuilderPermissionList= sessionStorage.getItem("manageQueryBuilderPermissionList");

      this.insACQuploadWorkbenchPermissionList = sessionStorage.getItem("insACQuploadWorkbenchPermissionList");
      this.insACQschedulePermissionList = sessionStorage.getItem("insACQschedulePermissionList");
      this.insACQauditReportPermissionList = sessionStorage.getItem("insACQauditReportPermissionList");
      this.insACQuserPermissionList = sessionStorage.getItem("insACQuserList");
      this.insACQreviewCrawlPermissionList = sessionStorage.getItem("insACQreviewCrawlPermissionList");
      this.insACQmissedActionPermissionList = sessionStorage.getItem("insACQmissedActionPermissionList");
      this.insACQinstanceAndSchedulesPermissionList = sessionStorage.getItem("insACQinstanceAndSchedulesPermissionList");
      this.insACQmissedDataPermissionList = sessionStorage.getItem("insACQmissedDataPermissionList");

      //Insurance Form
      this.insuranceFormuploadWorkbenchPermissionList = sessionStorage.getItem("insuranceFormuploadWorkbenchPermissionList");
      this.insuranceFormschedulePermissionList = sessionStorage.getItem("insuranceFormschedulePermissionList");
      this.insuranceFormauditReportPermissionList = sessionStorage.getItem("insuranceFormauditReportPermissionList");
      this.insuranceFormuserPermissionList = sessionStorage.getItem("insuranceFormuserList");
      this.insuranceFormreviewCrawlPermissionList = sessionStorage.getItem("insuranceFormreviewCrawlPermissionList");
      this.insuranceFormmissedActionPermissionList = sessionStorage.getItem("insuranceFormmissedActionPermissionList");
      this.insuranceForminstanceAndSchedulesPermissionList = sessionStorage.getItem("insuranceForminstanceAndSchedulesPermissionList");
      this.insuranceFormmissedDataPermissionList = sessionStorage.getItem("insuranceFormmissedDataPermissionList");

      //MCE
      this.mceuploadWorkbenchPermissionList = sessionStorage.getItem("mceuploadWorkbenchPermissionList");
      this.mceschedulePermissionList = sessionStorage.getItem("mceschedulePermissionList");
      this.mceauditReportPermissionList = sessionStorage.getItem("mceauditReportPermissionList");
      this.mceuserPermissionList = sessionStorage.getItem("mceuserList");
      this.mcereviewCrawlPermissionList = sessionStorage.getItem("mcereviewCrawlPermissionList");
      this.mcemissedActionPermissionList = sessionStorage.getItem("mcemissedActionPermissionList");
      this.mceinstanceAndSchedulesPermissionList = sessionStorage.getItem("mceinstanceAndSchedulesPermissionList");
      this.mcemissedDataPermissionList = sessionStorage.getItem("mcemissedDataPermissionList");
    }
  }

  addClassActive() {
    collapseMenu();
  }
}
